export default "__VITE_ASSET__Dnadzrcy__"